﻿import React, { Fragment, useState, useEffect, useCallback } from 'react';
import axios from 'axios';

import { Route, Routes, Navigate } from 'react-router-dom';
import { VerticalLinkGroup, Breadcrumbs } from 'components/navigation';
import { UserGeneralSettings } from 'pages/users/edit/general-settings';
import {  AccountService, MfaService, UserService } from 'services';
import { ShowHide } from 'components/layout';
import { UserPreferences } from './preferences/UserPreferences';
import _ from 'underscore';
import { UserMfaSettings } from 'pages/users/edit/mfa/UserMfaSettings';

export function UserProfile(props) {
    const [loadingData, setLoadingData] = useState(true);
    const [isDriver, setIsDriver] = useState(null);
    const [ssoAccount, setSsoAccount] = useState(false);
    const [mfaIsEnabled, setMfaIsEnabled] = useState(false);

    const getRoutes = useCallback((hasDriverStatus, isMfaEnabled) => {

        var r = [
            { location: `/user/profile/general-settings`, title: "User Details" }
        ];

        if (hasDriverStatus != null && !hasDriverStatus) {
            r.push({ location: `/user/profile/preferences`, title: "Preferences" });
        }
        
        if (isMfaEnabled) {
            r.push({ location: `/user/profile/mfa`, title: "Multi-Factor Authentication" });
        }

        return r;
    }, [])

    const [routes, setRoutes] = useState(getRoutes(isDriver));

    const [user, setUser] = useState({
        role: {},
        firstName: "",
        lastName: "",
        emailAddress: "",
        phoneNumber: "",
    });

    useEffect(() => {
        setRoutes(getRoutes(isDriver, mfaIsEnabled));
    }, [isDriver, mfaIsEnabled]);

    useEffect(() => {

        if (loadingData) {

            axios.all([UserService.getLoggedInUser(), UserService.getRoles(), AccountService.getGeneralSettings(), getMfaSettings()]).then(axios.spread(function (userDetails, roles, accountGeneralSettings, mfaSettings) {

                var userRole = roles.filter(function (r) {
                    return r.key === userDetails.role
                })[0];

                setUser({
                    ...userDetails,
                    role: userRole
                });
                setLoadingData(false);
                setIsDriver(userDetails.role != null && userDetails.role.toUpperCase() === "DRIVERAPPUSER");
                setSsoAccount(accountGeneralSettings.ssoEnabled);
                setMfaIsEnabled(!!mfaSettings.allowedMfaTypes.length && !accountGeneralSettings.ssoEnabled);
            }));
        }
    }, [loadingData]);

    function getMfaSettings() {
        return MfaService.getCurrentUserMfaSettings()
            .catch((error) => {
                const invalidAccountStatusCode = 403;
                if (error.response && error.response.status === invalidAccountStatusCode) {
                    // If we get a 403, then this is likely an internal user on another account. In this case, we want to just return empty MFA settings since we won't be able to get the actual settings for this user.
                    return {
                        allowedMfaTypes: []
                    }
                }

                throw error;
            });
    }

    function onSave(modifiedUser) {
        setUser(modifiedUser);
    }

    return (
        <Fragment>
            <div className="row">
                <Breadcrumbs items={props.breadcrumbs} />
                <ShowHide
                    evaluator={user.firstName !== ""}
                    show={(<h1>{user.firstName + " " + user.lastName}</h1>)}
                    hide={(<h1>{user.emailAddress}</h1>)}
                />
                
            </div>

            <div className="layout-cols">
                <div className="col side-col">
                    <div className="row">
                        <VerticalLinkGroup links={routes}></VerticalLinkGroup>
                    </div>
                </div>
                <div className="col content-col">
                    <Routes>
                        <Route path="general-settings" element={<UserGeneralSettings user={user} loading={loadingData} onSave={onSave} ssoAccount={ssoAccount} editingOwnAccount={true} />} />
                        <Route path="" element={<Navigate to="/user/profile/general-settings" replace />} />
                        <Route path="preferences" element={<UserPreferences userId={user.userId} editingOwnAccount={true} />} />
                        <Route path="mfa" element={<UserMfaSettings userId={user.userId} editingOwnAccount={true}></UserMfaSettings>} />
                    </Routes>
                </div>
            </div>
        </Fragment>
    );

}